import { useNavigate } from "react-router-dom";

function useSmartBack(fallback = "/") {
  const navigate = useNavigate();

  const smartBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return smartBack;
}

export default useSmartBack;